/* @flow */
import LinkConstants from 'constants/LinkConstants';
import UserAgent from 'lib/UserAgent';

export function storeLinkFor(userAgent: UserAgent) {
  if (userAgent.ios()) {
    return LinkConstants.APP_STORE;
  } else if (userAgent.android()) {
    return LinkConstants.GOOGLE_PLAY;
  }
  // fallback to our own page that shows the different store links and has a UI
  // to get texted the download link
  return LinkConstants.APP_DOWNLOAD;
}
